export const RECIEVE_ENTITIES = "RECIEVE_ENTITIES";
